export enum SearchType {
    All = "All",
    Images = "Images",
  }
  